import React, {useState} from "react";
import {connect} from "react-redux";
import Panel from "../panel/Panel";
import Form from "./forms/Edit";
import {removeAction as removePanelAction} from "../../actions/panel";
import { UserOutlined } from '@ant-design/icons';
import { Button, Result, Spin } from "antd";
import EntityLoader from "../common/EntityLoader";

const Title = ({entity}) => <span>
    <UserOutlined /> {!!entity ? entity.username : '404 - Not Found'}
</span>;

const Content = connect(
    null,
    dispatch => ({
        onRemovePanel: (uniqueKey) => dispatch(removePanelAction(uniqueKey)),
    })
)(({entity, entityId, onRemovePanel}) => <>
    {entity
        ? <Form userId={entityId}/>
        : <Result
            status="404"
            title="404"
            subTitle="Sorry, the page you visited does not exist."
            extra={<Button type="primary" onClick={() => onRemovePanel(`users:${entityId}:edit`)}>close</Button>}
        />
    }
</>);

export default ({userId}) => {
    const [loading, setLoading] = useState(true);

    return <Panel
        backgroundColor="#ef7e06"
        id={`users:${userId}:edit`}
        title={
            <EntityLoader entityId={userId}>
                <Title/>
            </EntityLoader>
        }
    >
        <Spin spinning={loading}>
            <EntityLoader entityId={userId} onFinally={() => setLoading(false)}>
                <Content/>
            </EntityLoader>
        </Spin>
    </Panel>
};
